/**
 * 创收版版本规则（V5 / V6 / V7 …）—— 单一数据源
 *
 * 【版本角标图】平台方放在 f2 服务器：
 *   //f2.youbaolian.top/BakSite/Resources/img/version/{档位}_{版本}.png
 *     {档位} = partnerEx.v5Flag          1 试用版 / 3 入门版 / 4 标准版 / 5 专业版 / 6 旗舰版
 *     {版本} = partnerEx.revenueVersion  V5 / V6 / V7 …
 *   例：5_V6.png = V6 专业版、3_V5.png = V5 入门版
 *
 * 新增 V7 / V8 时平台方按同一命名规则传图即可，前端无需改代码；
 * 若新增档位，只需在 @/data/role 的 systemVersionFiveList 补一行。
 *
 * 【取值口径】
 *   - revenueVersion 为空按 V5（与登录写 partnerEx cookie、首页软件版本文案一致）
 *   - 无档位（v5Flag 为空）时取不到图，返回 ''，调用方据此不渲染角标
 */
import { role } from '@/data/role'
import cookie from './cookie'

// 版本角标图目录
export const VERSION_BADGE_BASE = '//f2.youbaolian.top/BakSite/Resources/img/version/'

/** partnerEx 兜底（兼容 partner 为空 / 未登录） */
export const getPartnerEx = (partner) => (partner && partner.partnerEx) || {}

/** 档位（v5Flag），原样返回，可能为 '' / undefined / 0 */
export const getVersionFlag = (partner) => getPartnerEx(partner).v5Flag || ''

/** 版本号（revenueVersion）→ 归一化为 V{n}；空或取不到数字一律按 V5 */
export const getRevenueVersion = (partner) => {
  const matched = String(getPartnerEx(partner).revenueVersion || '').match(/\d+/)
  return matched ? `V${matched[0]}` : 'V5'
}

/**
 * 版本角标图地址；无档位或取不到版本号时返回 ''（调用方以此判断是否渲染 img）
 * @returns 形如 //f2.youbaolian.top/BakSite/Resources/img/version/5_V6.png 的地址，或 ''
 */
export const getVersionBadgeUrl = (partner) => {
  const flag = getVersionFlag(partner)
  return flag ? `${VERSION_BADGE_BASE}${flag}_${getRevenueVersion(partner)}.png` : ''
}

/**
 * 「AI轻客服」菜单是否对当前商户可见：创收版 V6 及以上、且非入门版（v5Flag=3）。
 * 与「AI合伙人」同口径：是否有菜单权限由后端按权限下发控制，前端只做版本/档位拦截。
 * 版本上下文取传入 partner 的 partnerEx，取不到时回退登录写入的 partnerEx cookie（同 canUseSalesLabel）。
 */
export const canUseLightCustomerService = (partner) => {
  let partnerEx = (partner && partner.partnerEx) || null
  if (!partnerEx) {
    try {
      partnerEx = JSON.parse(cookie.getCookie('partnerEx') || 'null') || {}
    } catch (e) {
      partnerEx = {}
    }
  }
  const revenueMajor = parseFloat(String(partnerEx.revenueVersion || '').replace(/[^\d.]/g, '')) || 5
  return revenueMajor >= 6 && +partnerEx.v5Flag !== 3
}

/**
 * 软件版本文案（如 V6专业版）；无档位时返回 ''，调用方回退旧文案
 * 档位名取 systemVersionFiveList 并去掉其硬编码的 V5 前缀，再拼真实版本号
 */
export const getVersionLabel = (partner) => {
  const flag = +getVersionFlag(partner)
  if (!flag) return ''
  const item = (role.systemVersionFiveList || []).find(x => +x.value === flag)
  const tier = item ? String(item.label).replace(/^V5/, '') : ''
  return `${getRevenueVersion(partner)}${tier}`
}



// WEBPACK FOOTER //
// ./src/utils/version.js